<template>
    <div id="login">
        <nav>
            <center>
                <img id="logo" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
        </nav>
        <h1>SE CONNECTER</h1>
        <h4>{{ msg }}</h4>
        <input type="text" name="username" v-model="input.username" placeholder="Votre adresse mail..." />
        <input type="password" name="password" v-model="input.password" placeholder="Votre mot de passe..." />
        <button type="button" v-on:click="loginWeweb()">Connexion</button>
        <div class="pwd" v-on:click="password()"><u >Mot de passe oublié</u></div>
    </div>
</template>

<script>

    import axios from 'axios';

    export default {
        name: 'Login',
        data() {
            return {
                input: {
                    username: "",
                    password: ""
                },
                msg:""
            }
        },
        methods: {
            async getUserData(){
                var response = await axios.get('https://so.gaviota.fr/api/userdata')
                if(response.data.user){
                    this.$cookie.set('role', response.data.user.role, 30);
                    this.$cookie.set('firstName', response.data.user.address.firstName, 30);
                    this.$cookie.set('lastName', response.data.user.address.lastName, 30);
                    this.$cookie.set('idWeweb', response.data.user.idWeweb, 30);
                    if(response.data.user.role === "admin"){
                        this.$router.replace({ name: "adminhome" });
                    }
                    else if(response.data.user.role === "technicien chantier"){
                        this.$router.replace({ name: "techhome" });
                    }
                    else if(response.data.user.role === "technicien bureau"){
                        this.$router.replace({ name: "adminhome" });
                    }
                    else if(response.data.user.role === "client"){
                        this.$router.replace({ name: "home" });
                    }
                    else{
                        this.msg = "Mauvais identifiants";
                    }
                }
                else{
                    this.msg = "Mauvais identifiants";
                }

            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "login" });
            },
            password(){
                console.log("mdp oublié");
                this.$router.replace({ name: 'password' });
            },
            async loginWeweb() {
                try {
                    var response = await axios.post('https://so.gaviota.fr/api/userdata/login', 
                        {
                            "user": {
                                "emailAddress": this.input.username.toLocaleLowerCase(),
                                "password": this.input.password
                            }
                        }
                    );
                    if(response.data){
                        if(response.data.sessionToken){
                            this.$cookie.set('jwt', response.data.sessionToken, 30);
                            axios.defaults.headers.common['Authorization'] = response.data.sessionToken;
                            this.getUserData();
                        }
                        else{
                            this.msg = "Mauvais identifiants";
                        }
                    }
                    else{
                        this.msg = "Mauvais identifiants";
                    }
                } 
                catch (error) {
                    this.msg = "Mauvais identifiants";
                }
            }
        }
    }
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #login {
        width: 350px;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 200px;
        border:none;
        padding-bottom: 20px;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 550;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        display: block;
        text-align: center;
    }
    h4{
        background-color: #ff0000;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 550;
        margin:0;
        font-size: 18px;
        display: block;
        text-align: center;
    }
    input{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: 15px;
        width: 310px;
        padding-left:10px;
        padding-top:5px;
        padding-bottom:3px;
        background-color:rgb(232, 240, 254);
    }
    button{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: 15px;
        width: 320px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        padding-top:3px;
        padding-bottom:3px;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    img{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }
    .pwd{
        background-color: white;
        color: blue;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        padding-bottom:5px;
        padding-top:5px;
        margin:0;
        font-size: 15px;
        display: block;
        text-align: center;
        cursor: pointer;
    }

</style>